import { useTranslation } from 'next-i18next/pages';

import Area from '@/components/apps/layouts/shared/Area';
import AnimationSectionTitle from '@/components/apps/ui/title/AnimationSectionTitle';

import ListenAiCardList from './ListenAiCardList';

export default function ListenAiSection() {
  const { t } = useTranslation('common');

  return (
    // 배경은 image-set() + lg 미디어쿼리 이미지 교체라 globals.css 의 .listen-ai-bg 로 유지한다.
    <div className="listen-ai-bg bg-apps-coreGrayWhite">
      <Area>
        <div className="flex flex-col gap-[72px] pt-[100px] lg:gap-[clamp(72px,14.286vw,200px)] lg:pt-[clamp(100px,14.286vw,200px)]">
          <AnimationSectionTitle
            title="Listen AI"
            subtitle={t('중요한 소리를 놓치지 않는 사운드 인공지능 솔루션')}
          />
          <ListenAiCardList />
        </div>
      </Area>
    </div>
  );
}
